function klaviyoTrackAddToCart(cart) {
  if (!cart || !window.theme.klaviyo?.enabled || !window.theme.klaviyo?.enableAddToCartTracking) return;

  const klaviyo = window.klaviyo || [];
  klaviyo.push(['track', 'Added to Cart', cart]);
}

function klaviyoTrackViewedProduct(product) {
  if (!product || !window.theme.klaviyo?.enabled || !window.theme.klaviyo?.enableViewedProductTracking) return;

  const klaviyo = window.klaviyo || [];
  klaviyo.push([
    'track',
    'Viewed Product',
    {
      ...product,
      description: '',
      content: '',
    },
  ]);
}
export {klaviyoTrackViewedProduct, klaviyoTrackAddToCart};
